import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PMCListComponent from './PMCListComponent';

import { getPMCs, onPmcDelete } from './actionCreators';

import { getTodayCount, isAdmin } from '../../utils';

const LIST_KEY = 'pmcsList';

const PMCListContainer = (props) => {
  const { onGetPMCs, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    isAdmin() && Object.assign(queryParams, { only_direct_pmc: true });
    return onGetPMCs(queryParams);
  };
  return <PMCListComponent {...props} onExport={onExport} />;
};

PMCListContainer.propTypes = {
  onGetPMCs: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ pmcsList, common, lists }) => ({
  items: pmcsList,
  listKey: LIST_KEY,
  listParams: lists?.[LIST_KEY] || {},
  user: common?.currentUser || {},
});

const mapDispatchToProps = (dispatch) => ({
  getItems: (queryParams) => {
    isAdmin()
      ? getTodayCount(getPMCs, dispatch, queryParams)
      : Object.assign(queryParams, { only_direct_pmc: false });
    return getPMCs(dispatch, queryParams);
  },
  onPmcDelete: (PMC, listParams) => onPmcDelete(dispatch, PMC, listParams),
  onGetPMCs: (queryParams) => getPMCs(dispatch, queryParams, true),
});

export default connect(mapStateToProps, mapDispatchToProps)(PMCListContainer);
